import { brandStorage as localStorage } from '@/utils/brandSession';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function b64urlToBytes(value) {
  const pad = '='.repeat((4 - (value.length % 4)) % 4);
  const raw = atob(value.replace(/-/g, '+').replace(/_/g, '/') + pad);
  return Uint8Array.from(raw, c => c.charCodeAt(0));
}
function bytesToB64url(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach(b => { binary += String.fromCharCode(b); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function post(path, body) {
  const r = await fetch(API + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('hw_token')}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) {
    let detail = 'Errore';
    try { detail = (await r.json()).detail || detail; } catch (e) { /* noop */ }
    throw new Error(detail);
  }
  return r.json();
}

export function passkeySupported() {
  return !!window.PublicKeyCredential;
}

export async function registerPasskey() {
  if (!passkeySupported()) throw new Error('Questo dispositivo non supporta le passkey');
  const options = await post('/hr/passkey/register/options');
  return completeRegistration(options, (payload) => post('/hr/passkey/register/verify', payload));
}

// Registrazione via link invito (senza login): ritorna {verified, access_token, user}
export async function registerPasskeyWithInvite(inviteToken) {
  if (!passkeySupported()) throw new Error('Questo dispositivo non supporta le passkey');
  const options = await post(`/hr/invite/${inviteToken}/passkey/options`);
  return completeRegistration(options, (payload) => post(`/hr/invite/${inviteToken}/passkey/verify`, payload));
}

async function completeRegistration(options, verifyFn) {
  const publicKey = {
    ...options,
    challenge: b64urlToBytes(options.challenge),
    user: { ...options.user, id: b64urlToBytes(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map(c => ({ ...c, id: b64urlToBytes(c.id) })),
  };
  const c = await navigator.credentials.create({ publicKey });
  if (!c) throw new Error('Nessuna credenziale creata');
  return verifyFn({
    id: c.id,
    rawId: bytesToB64url(c.rawId),
    type: c.type,
    authenticatorAttachment: c.authenticatorAttachment,
    response: {
      clientDataJSON: bytesToB64url(c.response.clientDataJSON),
      attestationObject: bytesToB64url(c.response.attestationObject),
      transports: c.response.getTransports ? c.response.getTransports() : ['internal'],
    },
    clientExtensionResults: c.getClientExtensionResults(),
  });
}

export async function punchWithPasskey(punchType) {
  const options = await post('/hr/clock/options');
  const publicKey = {
    ...options,
    challenge: b64urlToBytes(options.challenge),
    allowCredentials: (options.allowCredentials || []).map(c => ({ ...c, id: b64urlToBytes(c.id) })),
    userVerification: 'required',
  };
  const c = await navigator.credentials.get({ publicKey });
  if (!c) throw new Error('Verifica annullata');
  return post('/hr/clock/verify', {
    punch_type: punchType,
    credential: {
      id: c.id,
      rawId: bytesToB64url(c.rawId),
      type: c.type,
      response: {
        clientDataJSON: bytesToB64url(c.response.clientDataJSON),
        authenticatorData: bytesToB64url(c.response.authenticatorData),
        signature: bytesToB64url(c.response.signature),
        userHandle: c.response.userHandle ? bytesToB64url(c.response.userHandle) : null,
      },
      clientExtensionResults: c.getClientExtensionResults(),
    },
  });
}
